export default __webpack_public_path__ + "static/media/LogoWhiteBoxed.419eb518.png";